import { render, staticRenderFns } from "./AdvancedSettingsProject.vue?vue&type=template&id=12273e2e&"
import script from "./AdvancedSettingsProject.vue?vue&type=script&lang=js&"
export * from "./AdvancedSettingsProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports